import { Box } from '@mui/material'

export const NewReplied = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(234, 67, 53, 0.1)',
        borderRadius: 1,

        display: 'flex',
        alignItems: 'center'
      }}
    >
      <img src='assets\CampingIcon-1.png' alt='Replied' width={32} height={32} />
    </Box>
  )
}
